import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';
import { ca } from 'date-fns/locale';

let initialized = false;

const initLestener = () => {
  if (initialized) return;
  initialized = true;

  if (window.config?.layout_light) return;

  let previousRow, currentRow;

  $(document).on('ajax:success', '.js-reload-presence', function () {
    return $('#list-presences').trigger('reloadGrid');
  });

  const createUrl = (url, date, guest_statuses_id) => {
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    if (date) {
      searchParams.append('date', date);
    }
    if (guest_statuses_id) {
      searchParams.append('guest_statuses_id', guest_statuses_id);
    }
    return urlObj.toString();
  };

  const changeTotal = (nameField, valueField, list) => {
    let footerData = list.jqGrid('footerData', 'get');
    const isFooterKey = nameField in footerData;

    if (!isFooterKey) return;

    const oldValue = footerData[nameField];
    const newValue = valueField ? parseInt(oldValue) + 1 : parseInt(oldValue) - 1;

    list.jqGrid('footerData', 'set', { [nameField]: newValue }, false);
  };

  const calcTotals = async (date, guest_statuses_id) => {
    const full_url = createUrl(
      `${window.config.ePersonamService.ePersonamHost}/${window.locale}/guest_presences/daily/totals.json`,
      date,
      guest_statuses_id,
    );
    const { data } = await apiConnector().get(full_url);
    const row = {
      reload: 'Totale',
      ...data,
    };

    return $('#list-presences').jqGrid('footerData', 'set', row, false);
  };

  const fCellAttr = function (rowId, val, rawObject, cm, rdata) {
    const attuale = rdata[cm['name']];
    const previsione = rawObject[cm['name'].replace(/\]$/, '_prev]')];
    const previsto_assente = previsione === false;
    let classes = [];
    classes.push(previsto_assente ? 'nvar' : 'pvar');
    if (previsione !== attuale) {
      classes.push('variation');
    }
    return 'class="' + classes.join(' ') + '"';
  };

  const gpAfterUpdate = function (data) {
    const cellToUpdate = $('#gp_' + data.id + ' > div.js-popup');
    cellToUpdate.html(data.cod);
    if (data.present) {
      cellToUpdate.removeClass('avar');
      if (data.variations) {
        cellToUpdate.addClass('variation');
        cellToUpdate.removeClass('present');
        cellToUpdate.addClass('pnvar');
      } else {
        cellToUpdate.removeClass('variation');
        cellToUpdate.addClass('present');
        cellToUpdate.removeClass('pnvar');
      }
    } else {
      cellToUpdate.addClass('avar');
      cellToUpdate.addClass('variation');
      cellToUpdate.removeClass('present');
      cellToUpdate.removeClass('pnvar');
    }
  };

  const fDataInit = function (elem) {
    var tdSelector;
    tdSelector = 'td#' + $(elem).parent().uniqueId()[0].id;
    $(elem).addClass('js-class-toggler');
    $(elem).addClass('js-click-toggler');
    $(elem).attr('data-toggler-target', tdSelector);
    $(elem).attr('data-toggler-class', 'variation');
    if (!$(tdSelector).hasClass('nvar')) {
      return $(elem).attr('data-negative-logic', true);
    }
  };

  const fDataInitSelect = function (elem) {
    if ($(elem).prop('name') === 'guest_presence[cause_id]') {
      $(elem).addClass('js-cause-id');
    }
    return $(elem).addClass('js-select-toggler');
  };

  const fDataInitNotes = function (elem) {
    return $(elem).addClass('js-notes-toggler');
  };

  const initGP = function () {
    $('form.guest_presence_form .mychzn, form.guest_presence_form .mychzn-obbligatorio').on('change', function () {
      const disabled = $('.presence--table td.variation').length && $(this).children('select').val() === '';
      return $('form.guest_presence_form input[type=submit]').prop('disabled', disabled);
    });
    $('.presence--table .js-class-toggler').on('change', function () {
      return $(this).trigger('presence:click');
    });
    if ($('.table-presence').length) {
      eventBus.$on('jsPopupCloseOnSubmitEvent', gpAfterUpdate);
    }
    return $('form.guest_presence_form').on('presence:click', '.js-class-toggler', function (ev) {
      const tds = $('.presence--table td.variation:not(:has(#' + ev.target.id + '))');
      let sel = $('form.guest_presence_form .mychzn, form.guest_presence_form .mychzn-obbligatorio');
      if (!tds.length) {
        if (sel.hasClass('mychzn')) {
          sel.removeClass('mychzn');
          sel.addClass('mychzn-obbligatorio');
          if (sel.children('select').val() === '') {
            return $('form.guest_presence_form input[type=submit]').prop('disabled', true);
          }
        } else if (sel.hasClass('mychzn-obbligatorio')) {
          sel.removeClass('mychzn-obbligatorio');
          sel.addClass('mychzn');
          return $('form.guest_presence_form input[type=submit]').prop('disabled', false);
        }
      }
    });
  };

  const getErrorModal = function (rowID, response) {
    const resp = JSON.parse(response.responseText);
    resp['cause_id'] ? alert(window.motivazione + ' ' + resp['cause_id'][0]) : alert(response.responseText);
    return $('#list-presences').jqGrid('editRow', rowID, true);
  };

  $(document).on('ajax:success', '.guest_presence_form, .js-form-load-presence', function (evt, data) {
    window.Popup.closeParent();
    window.Popup.closeCurrentPopup();
    let span = $('#popover_guest_presence_' + data['id']);
    span.popover('destroy');
    span.popover({
      content: data['content'],
      html: true,
      trigger: 'click',
      placement: 'bottom',
    });
    data['variations'] ? span.addClass('variation') : span.removeClass('variation');
    data['present'] && !data['variations'] ? span.addClass('present') : span.removeClass('present');
    return span.html(data['cod']);
  });

  $(document).on('ajax:error', '.guest_presence_form', function (evt, xhr) {
    const resp = JSON.parse(xhr.responseText);
    if (resp['cause_id']) {
      return alert(window.motivazione + ' ' + resp['cause_id'][0]);
    } else {
      let message = '';
      $.each(resp, function (k, v) {
        return (message += k + ': ' + v + '\n');
      });
      return alert(message);
    }
  });

  document.querySelector('#presences_table')?.addEventListener('click', (e) => {
    const isSummaryButton = e.target.classList.contains('.js-pres-summary') || e.target.closest('.js-pres-summary');

    if (isSummaryButton) {
      const dataset = e.target.closest('.js-pres-summary').dataset || e.target.dataset;

      eventBus.$emit('summaryPopupOpen', dataset);
    }
  });

  const set_popover = function (cellValue) {
    var full_name, info_ass, info_nucleo, info_room, obj, text;
    obj = $(cellValue);
    full_name = obj.find('.media-body span.full_name').html().replace(/<br>/g, '\n');
    info_nucleo = obj.find('.media-body span.unit_description').html().replace(/<br>/g, '\n');
    info_room = obj.find('.media-body span.room_description').html();
    if (info_room != null) {
      info_room = info_room.replace(/<br>/g, '\n');
    }
    info_ass = obj.find('.media-body span.ass_description').html();
    if (info_ass != null) {
      info_ass = info_ass.replace(/<br>/g, '\n');
    }
    text = full_name;
    text = text + '\n' + info_nucleo;
    if (info_room != null) {
      text = text + ' ' + info_room;
    }
    if (info_ass != null) {
      text = text + '\n' + info_ass;
    }
    return 'title = "' + text + '"';
  };

  const trasportoWhoSelect = function (cellvalue, options, rowObject) {
    var id, inputs, list, select_options, values;
    list = $('#list-presences');
    id = options['rowId'];
    inputs = '';
    values = cellvalue.split(',');
    select_options = {
      0: {
        cod: 'transport_who',
        label: 'M',
      },
      1: {
        cod: 'transport_who_p',
        label: 'P',
      },
    };
    $.each(values, function (i, v) {
      inputs +=
        '<select role="select" class="js-select-toggler input-medium submitable_cell editable ' +
        id +
        '_transport_who" id="' +
        id +
        '_guest_presences_' +
        select_options[i]['cod'] +
        '" data-attribute="' +
        select_options[i]['cod'] +
        '" name="guest_presences_transport_who" size="1">';
      $.each(list.data('transport').split(';'), function (k, val) {
        var desc, valori;
        valori = val.split(':');
        desc = valori[1];
        return (inputs +=
          valori[0] === v
            ? '<option value="' + valori[0] + '"  selected="selected">' + desc + '</option>'
            : '<option value="' + valori[0] + '">' + desc + '</option>');
      });
      return (inputs += '</select>' + select_options[i]['label'] + '<br/>');
    });
    return inputs;
  };

  const trasportoCheck = function (cellvalue, options, rowObject) {
    var id, inputs, select_options, values;
    id = options['rowId'];
    inputs = '';
    values = cellvalue.split(',');
    select_options = {
      0: {
        cod: 'trasporto',
        label: 'M',
      },
      1: {
        cod: 'trasporto_p',
        label: 'P',
      },
    };
    $.each(values, function (i, v) {
      var checked;
      checked = v === 'true' ? 'checked' : '';
      return (inputs +=
        select_options[i]['label'] +
        ': <input ' +
        checked +
        ' type="checkbox" id="' +
        id +
        '_guest_presences_' +
        select_options[i]['cod'] +
        '" class="js-click-toggler" name="guest_presences["' +
        select_options[i]['cod'] +
        '"]" value="true"/><br/>');
    });
    return inputs;
  };

  const list = $('#list-presences');
  const motivation_label =
    window.motivazione +
    ' <a title="Decodifica" id="link_decodes" data-remote="true" href="/it/decodes_configs.js?cod=guest_presence&key=cause_id"><i class="fa-light fa-list"></i></a>';
  const trasporto_label = list.data('asp-gasparini') ? window.trasporto_mp : window.trasporto;
  const trasporto_who_label =
    trasporto_label +
    ' <a title="Decodifica" id="link_decodes" data-remote="true" href="/it/decodes_configs.js?cod=guest&key=transport_who"><i class="fa-light fa-list"></i></a>';
  let colNames = ['id', '', window.guest_label];
  let colModel = [
    {
      name: 'guest_presence[id]',
      index: 'guest_presence[id]',
      width: 55,
      editable: false,
      hidden: true,
    },
    {
      name: 'reload',
      index: 'reload',
      width: 110,
      editable: false,
      hidden: false,
      align: 'center',
    },
    {
      name: 'guest_presence_guest_full_name',
      index: 'guest_presence_guest_full_name',
      width: 200,
      editable: false,
      sortable: false,
      cellattr: function (rowId, cellValue, rawObject, cm, rdata) {
        return set_popover(cellValue);
      },
    },
  ];
  if (list && list.data('tipo') === 'educativa') {
    colNames = colNames.concat([window.presente, 'presente_prev']);
    colModel = colModel.concat([
      {
        name: 'guest_presence[presente]',
        index: 'guest_presence[presente]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[presente_prev]',
        index: 'guest_presence[presente_prev]',
        width: 0,
        editable: false,
        hidden: true,
      },
    ]);
  } else {
    colNames = colNames.concat([window.mattina, 'mattina_prev', window.pomeriggio, 'pomeriggio_prev', window.notte, 'notte_prev']);
    colModel = colModel.concat([
      {
        name: 'guest_presence[mattina]',
        index: 'guest_presence[mattina]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[mattina_prev]',
        index: 'guest_presence[mattina_prev]',
        hidden: true,
        editable: false,
      },
      {
        name: 'guest_presence[pomeriggio]',
        index: 'guest_presence[pomeriggio]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[pomeriggio_prev]',
        index: 'guest_presence[pomeriggio_prev]',
        editable: false,
        hidden: true,
      },
      {
        name: 'guest_presence[notte]',
        index: 'guest_presence[notte]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[notte_prev]',
        index: 'guest_presence[notte_prev]',
        editable: false,
        hidden: true,
      },
    ]);
  }
  colNames = colNames.concat([motivation_label, trasporto_label, trasporto_who_label]);
  colModel = colModel.concat([
    {
      name: 'guest_presence[cause_id]',
      index: 'guest_presence[cause_id]',
      width: 150,
      align: 'center',
      sortable: false,
      editable: true,
      edittype: 'select',
      formatter: 'select',
      editoptions: {
        value: list.data('cause-id'),
        class: 'input-block-level',
        dataInit: fDataInitSelect,
      },
    },
  ]);
  if (list.data('asp-gasparini')) {
    colModel = colModel.concat([
      {
        name: 'guest_presence_trasporto',
        index: 'guest_presence_trasporto',
        width: 160,
        align: 'center',
        sortable: false,
        editable: false,
        fixed: true,
        formatter: trasportoCheck,
      },
      {
        name: 'guest_presence_transport_who',
        index: 'guest_presence_transport_who',
        width: 160,
        align: 'center',
        sortable: false,
        editable: false,
        fixed: true,
        formatter: trasportoWhoSelect,
      },
    ]);
  } else {
    colModel = colModel.concat([
      {
        name: 'guest_presence[trasporto]',
        index: 'guest_presence[trasporto]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[transport_who]',
        index: 'guest_presence[transport_who]',
        width: 100,
        align: 'center',
        sortable: false,
        editable: true,
        edittype: 'select',
        formatter: 'select',
        editoptions: {
          value: list.data('transport'),
          class: 'input-block-level',
          dataInit: fDataInitSelect,
        },
      },
    ]);
  }
  if (list && list.data('tipo') === 'educativa') {
    colNames = colNames.concat([window.pranzo]);
    colModel = colModel.concat([
      {
        name: 'guest_presence[pranzo]',
        index: 'guest_presence[pranzo]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
    ]);
  } else {
    colNames = colNames.concat([window.colazione, window.pranzo, window.cena, window.terapia_mattina, window.terapia_pomeriggio]);
    colModel = colModel.concat([
      {
        name: 'guest_presence[colazione]',
        index: 'guest_presence[colazione]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[pranzo]',
        index: 'guest_presence[pranzo]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[cena]',
        index: 'guest_presence[cena]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[terapia_mattina]',
        index: 'guest_presence[terapia_mattina]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
      {
        name: 'guest_presence[terapia_pomeriggio]',
        index: 'guest_presence[terapia_pomeriggio]',
        width: 30,
        align: 'center',
        sortable: false,
        editable: true,
        formatter: 'checkbox',
        edittype: 'checkbox',
        stype: 'select',
        editoptions: {
          value: 'true:false',
          dataInit: fDataInit,
        },
        cellattr: fCellAttr,
      },
    ]);
  }
  colNames = colNames.concat([window.notes_label]);
  colModel = colModel.concat([
    {
      name: 'guest_presence[notes]',
      index: 'guest_presence[notes]',
      width: 200,
      sortable: false,
      editable: true,
      edittype: 'textarea',
      editoptions: {
        rows: '2',
        cols: '30',
        class: 'input-block-level',
        dataInit: fDataInitNotes,
      },
    },
  ]);

  const savePresence = function (element) {
    var extraparam, id, value, name;
    id = element.prop('id').split('_')[0];
    name = element.attr('name');
    value = element.prop('checked');

    if (list.data('asp-gasparini')) {
      extraparam = {
        guest_presence: {
          trasporto: $('#' + id + '_guest_presences_trasporto').is(':checked'),
          trasporto_p: $('#' + id + '_guest_presences_trasporto_p').is(':checked'),
          transport_who: $('#' + id + '_guest_presences_transport_who').val(),
          transport_who_p: $('#' + id + '_guest_presences_transport_who_p').val(),
        },
      };
    } else {
      extraparam = {};
    }

    list.jqGrid('saveRow', id, {
      url: list.data('edit') + '/' + id + '.json',
      mtype: 'PUT',
      extraparam: extraparam,
      restoreAfterError: false,
      errorfunc: getErrorModal,
      aftersavefunc: function (row_id, data) {
        list.jqGrid('editRow', row_id, true);
        if (list.data('show-presence-summary')) {
          currentRow = list.jqGrid('getRowData', row_id);
          const cause_id = document.querySelector(`.js-cause-id[id*="${row_id}_"]`).value;
          currentRow['guest_presence[cause_id]'] = cause_id;
          eventBus.$emit('changeGuestPresencesSummary', { previousRow, currentRow });
        }
        changeTotal(name, value, list);

        return $('#link-to-diary-guest-presence-' + data['responseJSON']['id']).prop('href', data['responseJSON']['link_to_diary']);
      },
    });
  };

  if (list.length && list.data('show-presence-summary')) {
    list.on('mouseenter focus', 'tr.jqgrow', function () {
      const rowid = this.id;
      previousRow = list.jqGrid('getRowData', rowid);
      const cause_id = document.querySelector(`.js-cause-id[id*="${rowid}_"]`).value;
      previousRow['guest_presence[cause_id]'] = cause_id;
    });
  }

  $(document).on('click', '#list-presences .js-click-toggler', function (ev) {
    var cause, element, id;
    element = $(ev.target);
    if (
      element.prop('name') === 'guest_presence[mattina]' ||
      element.prop('name') === 'guest_presence[pomeriggio]' ||
      element.prop('name') === 'guest_presence[notte]' ||
      element.prop('name') === 'guest_presence[presente]'
    ) {
      id = element.prop('id').split('_')[0];
      cause = $('.js-cause-id[id^=' + id + '_]');
      if (
        (cause.val() == null || cause.val() === '') &&
        ((element.is(':checked') && element.parent().hasClass('nvar')) || (!element.is(':checked') && element.parent().hasClass('pvar')))
      ) {
        cause.val($('.js-cause-id[id^=' + id + '_] option:nth-child(2)').val());
      }
    }
    return setTimeout(function () {
      return savePresence(element);
    }, 10);
  });

  $(document).on('change', '#list-presences .js-select-toggler', function (ev) {
    return savePresence($(ev.target));
  });

  $(document).on('focusout', '#list-presences .js-notes-toggler', function (ev) {
    return savePresence($(ev.target));
  });

  list.jqGrid({
    url: list.data('index'),
    postData: {
      date: list.data('date'),
    },
    datatype: 'json',
    jsonReader: {
      repeatitems: false,
      id: 'guest_presence[id]',
      root: function (obj) {
        return obj['record'];
      },
      page: function (obj) {
        return obj['page'];
      },
      total: function (obj) {
        return obj['total'];
      },
      records: function (obj) {
        return obj['records'] + 1;
      },
    },
    colNames: colNames,
    colModel: colModel,
    viewsortcols: [true, 'vertical', false],
    loadComplete: function (response) {
      const { page, ef_decodes, record, date, guest_statuses_id } = response;

      if (list.data('show-presence-summary')) {
        eventBus.$emit('loadGuestPresencesSummary', { page, ef_decodes, record, date, guest_statuses_id });
      }
      if (page == 1 && record.length) {
        calcTotals(date, guest_statuses_id);
      }
    },
    gridComplete: function () {
      var ids, j, jqgid, len, results;
      ids = list.jqGrid('getDataIDs').reverse();
      results = [];
      for (j = 0, len = ids.length; j < len; j++) {
        jqgid = ids[j];
        results.push(list.jqGrid('editRow', jqgid, true));
      }
      return results;
    },
    rowNum: 10,
    rowList: [10, 20, 30],
    viewrecords: true,
    scroll: true,
    autowidth: true,
    height: 330,
    footerrow: true,
    userDataOnFooter: true,
  });

  initGP();

  if (!$('.table-presence').hasClass('empty')) {
    $('.table-presence').fixedHeaderTable({
      footer: false,
      cloneHeadToFoot: false,
      fixedColumn: false,
      height: 500,
    });
  }

  $(window).on('resize', function () {
    var outerwidth;
    outerwidth = $('#presences_table').width();
    return $('#list-presences').setGridWidth(outerwidth);
  });
};

const init = () => {
  try {
    initLestener();
  } catch (e) {
    errorManager(e);
  }
};

window.GuestPresences = {
  init: init,
};
